import uploadTemplate from '../templates/upload.hbs';
import $ from 'jquery';
import EXIF from '../../js/exif-js/exif';
import {ajaxRequest} from '../../sinclair/sinclair.ajax';

$.fn.sdaUpload = function(options) {
    const opts = $.extend(true, {}, $.fn.sdaUpload.defaults, options);

    // eslint-disable-next-line max-statements
    return this.each(function() {
        const $this = $(this);
        const data = $this.data();

        function _createGUID() {
            function s4() {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1); //eslint-disable-line no-bitwise
            }
            return (
                s4() +
                s4() +
                '-' +
                s4() +
                '-4' +
                s4().substr(0, 3) +
                '-' +
                s4() +
                '-' +
                s4() +
                s4() +
                s4()
            ).toLowerCase();
        }

        opts.id = $this.attr('id') ? 'input-' + $this.attr('id') : 'input-' + _createGUID();
        $.extend(true, opts, data);
        const template = uploadTemplate(opts);
        if ($this.attr('type') === 'file') {
            opts.input = $this;
            $this.addClass('sda-input-file');
            $this.parent().css('position', 'relative');
        } else {
            //use template here to create uploasd widget
            $this.html(template);
            opts.input = $this.find('input[type="file"]');
        }

        const debug = {
            // eslint-disable-next-line no-console
            log: opts.debug ? console.log.bind(console, 'sdaUpload') : $.noop,
        };

        //events

        function initEvents() {
            opts.input.on('change', function(e) {
                const target = e.dataTransfer || e.target;
                const files = target && target.files && target.files;

                for (const file in files) {
                    if (typeof files[file] === 'object') {
                        if (files[file].type.includes('image')) {
                            _getMetaData(files[file]);
                            uploadAjax(files[file], '/api/rest/facade/image/upload');
                        } else {
                            uploadAjax(files[file], '/api/rest/facade/video/upload');
                        }
                    }
                }
            });
        }
        initEvents();

        function _getMetaData(file) {
            const $deferred = $.Deferred();

            EXIF.getData(file, function() {
                debug.log('img', this.iptcdata);
                opts.iptcdata = this.iptcdata;
                opts.exifdata = this.exifdata;
                debug.log(EXIF.pretty(this));
                $deferred.resolve();
            });

            return $deferred;
        }

        function _getImageSize(file) {
            const renditions = opts.renditions;
            const scaledRenditions = [];
            const $deferred = $.Deferred();
            if (renditions && renditions.length) {
                const imageObj = new Image();
                const _URL = window.URL || window.webkitURL;
                // eslint-disable-next-line max-statements,complexity
                imageObj.onload = function() {
                    const img = {
                        width: this.width,
                        height: this.height,
                        ratio: {
                            x: 3,
                            y: 4,
                        },
                        orientation: this.width > this.height ? 'horizontal' : 'vertical',
                    };
                    img.display = img.ratio.y / img.ratio.x > 1 ? 'vertical' : 'horizontal';

                    if (img.orientation === 'vertical') {
                        img.scaleWidth = img.width;
                        img.scaleHeight = (img.width / img.ratio.x) * img.ratio.y;
                        img.offset = {
                            x: 0,
                            y: (img.height - img.scaleHeight) / 2,
                        };

                        if (img.scaleHeight < img.height) {
                            img.scaleWidth = (img.scaleHeight / img.ratio.y) * img.ratio.x;
                            img.offset = {
                                x: (img.width - img.scaleWidth) / 2,
                                y: (img.height - img.scaleHeight) / 2,
                            };
                        }
                    } else if (img.orientation === 'horizontal') {
                        img.scaleHeight = img.height;
                        img.scaleWidth = (img.height / img.ratio.y) * img.ratio.x;

                        img.offset = {
                            x: (img.width - img.scaleWidth) / 2,
                            y: 0,
                        };
                        if (img.display === 'horizontal') {
                            if (img.scaleWidth < img.width) {
                                img.scaleHeight = (img.scaleWidth / img.ratio.y) * img.ratio.x;
                                img.offset = {
                                    x: (img.width - img.scaleWidth) / 2,
                                    y: (img.height - img.scaleHeight) / 2,
                                };
                            }
                        } else {
                            if (img.scaleHeight < img.height) {
                                img.scaleWidth = (img.scaleHeight / img.ratio.y) * img.ratio.x;
                                img.offset = {
                                    x: (img.width - img.scaleWidth) / 2,
                                    y: (img.height - img.scaleHeight) / 2,
                                };
                            }
                        }
                    }

                    // eslint-disable-next-line guard-for-in
                    for (const rendition in renditions) {
                        scaledRenditions.push({
                            name: renditions[rendition].name,
                            id: _createGUID(),
                            width: img.scaleWidth,
                            height: img.scaleHeight,
                            x: img.offset.x,
                            y: img.offset.y,
                            scaleWidth: renditions[rendition].scaleWidth,
                        });
                    }

                    debug.log('---------->', img, scaledRenditions);
                    opts.renditions = scaledRenditions;
                    $deferred.resolve();
                };
                imageObj.src = _URL.createObjectURL(file);
            } else {
                opts.renditions = renditions;
                $deferred.resolve();
            }
            return $deferred;
        }

        function createMultipartFormData(file) {
            const formData = new FormData();
            const deferred = _getImageSize(file);
            const $deferred = $.Deferred();
            deferred.done(function() {
                debug.log('WIDGET::sdaUpload: createMultipartFormData->deferred');
                formData.append('file', file);
                formData.append(
                    'data',
                    JSON.stringify({
                        filename: !opts.name ? file.name : opts.name,
                        externalId: !opts.externalId ? _createGUID() : opts.externalId,
                        images: opts.renditions,
                    }),
                );
                // eslint-disable-next-line no-console
                console.info(opts.renditions);
                opts.formData = formData;
                $deferred.resolve();
            });

            return $deferred;
        }

        function _beforeSend() {
            debug.log('WIDGET::sdaUpload: beforeSend');
            opts.beforeSend.call(this, '', $this, ...arguments);
        }

        function _success(response) {
            response.data[0].iptcdata = opts.iptcdata;
            debug.log('WIDGET::sdaUpload: success', response);
            opts.success.call(this, response, $this);
        }

        function _complete(response) {
            debug.log('WIDGET::sdaUpload: complete', response);
            opts.complete.call(this, response, $this);
        }

        function _done(response) {
            debug.log('WIDGET::sdaUpload: done: ', response);
            opts.done.call(this, response.data[0].images, $this);
        }

        function _error(response) {
            // eslint-disable-next-line no-console
            console.log('WIDGET::sdaUpload: error uploading image: ', response.status, ' ', response.statustext);
            opts.error.call(this, response, $this);
        }

        function uploadAjax(file, url) {
            const deferred = createMultipartFormData(file);
            deferred.done(function() {
                debug.log('WIDGET::sdaUpload: uploadAjax->deferred: ' + file + ' : ' + url);
                ajaxRequest({
                    url,
                    data: opts.formData,
                    processData: opts.processData,
                    contentType: opts.contentType,
                    type: opts.type,
                    beforeSend: _beforeSend,
                    success: _success,
                    complete: _complete,
                    error: _error,
                }).done(_done);
            });
        }
    });
};

$.fn.sdaUpload.defaults = {
    debug: false,
    name: null,
    externalId: null,
    renditions: [], // null creates the default set of renditions
    container: '',
    url: '/api/rest/facade/image/upload',
    processData: false,
    contentType: false,
    type: 'POST',
    models: null,
    success() {},
    error() {},
    beforeSend() {},
    complete() {},
    done() {},
    onDebug() {},
};

export default $;
